// extracted by mini-css-extract-plugin
export var centerText = "_ff-8";
export var container = "_ff-0";
export var doughnutContainer = "_ff-7";
export var legend = "_ff-a";
export var legendItemColorDisplay = "_ff-b";
export var legendItemLabel = "_ff-d";
export var legendItemValue = "_ff-c";
export var lg = "_ff-5";
export var maxWidth = "_ff-9";
export var md = "_ff-4";
export var responsive = "_ff-6";
export var sm = "_ff-3";
export var xs = "_ff-2";
export var xxs = "_ff-1";